/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: newsletter-webapp-contrib
 * Version: 7.1.0
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(function($) {
    'use strict';

    $.extend( $.fn.dataTableExt.oSort, {
        'date-time-jjmmaaaahhiiss-pre': function ( a ) {
            var datetime = a.split(' ');
            var date = datetime[0].split('/');
            var time = datetime[1].split(':');
            return date[2] + date[1] + date[0] + time[0] + time[1] + time[2];
        },
        'date-time-jjmmaaaahhiiss-asc': function ( x, y ) {
            return ((x < y) ? -1 : ((x > y) ?  1 : 0));
        },
        'date-time-jjmmaaaahhiiss-desc': function ( x, y ) {
            return ((x < y) ?  1 : ((x > y) ? -1 : 0));
        }
    });

    var dataTableLogs = $('.dataTableNewsletters');
    dataTableLogs.dataTable({
        'aoColumns': [
                      null,
                      {
                          'sType': 'date-time-jjmmaaaahhiiss'
                      },
                      {
                          'bSearchable': false,
                          'bSortable': false
                      }
                  ]
          });

})(jQuery.noConflict());